export class MessageBoxOptions {
    public size: string; // small|medium|large
    public allowClose: boolean;

    constructor(size?: string, allowClose?: boolean) {
        this.size = size;
        this.allowClose = allowClose;
    }
}
